<template>
    <b-spinner style="width: 3rem; height: 3rem; margin: 100px auto; display: block;" label="Large Spinner"  v-show="loading" />
</template>

<script>
export default {
  name: 'Spinner',
  props: ['loading']
}
</script>

<style scoped>
</style>
